import React from 'react'
import { LeaveGuard } from '../../../../shared/sso-workspace/leave-guard'
import { SecretField } from '../../../../shared/secret/secret-field'
import { SecretDialog, SecretSection } from '../../../../shared/secret/secret-dialog'

// A new (or rotated) publish key's secret, shown once: the service keeps
// only a hash. Masked until Show. Escape and the backdrop do nothing; the
// only way out is "I've stored it", so a stray key or click can't lose the
// secret. It lives only in this dialog's props, handed down by the page
// until onDone.
export const KeySecretDialog = ({ secret, repo, onDone }) =>
  <>
    <SecretDialog title="Copy your new publish key" backdropTestId="package-key-secret-backdrop" onDone={onDone} focus="first"
      note="Copy this key now. It won't be shown again.">
      <SecretSection n={1} title="Publish key">
        <SecretField value={secret} noun="publish key" testId="package-key-secret" />
      </SecretSection>
      <SecretSection n={2} title="Store it">
        <p className="m-0">Store it as the GitHub Actions secret EDXR_API_KEY in {repo || "the package's repository"}.</p>
      </SecretSection>
    </SecretDialog>
    <LeaveGuard when title="Copy the key first" label="Copy the key first" leaveLabel="Leave and lose the key"
      message="The publish key is shown only once. If you leave now, it can't be shown again and you will need to create a new key." />
  </>
